import {useEffect} from 'react';

import MojitoCore from 'mojito/core';
import MojitoPresentation from 'mojito/presentation';

const {dispatch} = MojitoCore.Services.redux.store;
const IntentTypes = MojitoPresentation.Base.Intent.Types;
const IntentActions = MojitoCore.Intents.actions;
const IntentActionTrigger = MojitoPresentation.Base.Intent.IntentActionTrigger;

export function OpenBetsRoute() {
    useEffect(() => {
        IntentActionTrigger.showHomePage();

        // Added only SHOW_SLIDING_OPEN_BETS without SHOW_OPEN_BETS, as this feature was requested only for the native app
        dispatch(IntentActions.publishIntent(IntentTypes.SHOW_SLIDING_OPEN_BETS));
    }, []);

    return null;
}
